import { customerCardStyles } from "@insite/content-library/Components/CustomerCard";
import { css } from "styled-components";

Object.assign(customerCardStyles, {
    ...customerCardStyles,
    selectButton: {
        variant: "primary",
        css: css`
            padding: 0px 21px;
            :hover {
                background-color: #ab161a;
                border-color: #ab161a;
            }
        `,
    },
});
